import { PatientInvisalignPublicPage } from '@elva/ui';

/** Patient-facing public Invisalign page — no app shell or staff nav. */
export function PatientInvisalignPublicPageRoute() {
  return <PatientInvisalignPublicPage />;
}
